//部门授权分拨菜单引导提示
const stepsAlloCation=()=>[
    {
        element: '#depEmpowerAllocation',
        popover: {
            title: ' ',
            description: '<div style="padding:30px 90px 20px 90px;display:flex" ><div><div style="display:flex"><i class="iconfont icon-yijianfankui" style="color:#35B065;font-size:40px;padding-right:15px"></i> <div style="padding-top:15px;font-family: MicrosoftYaHei;font-size: 18px;color: #333333;">系统更新升级通知！</div></div>    <div style="font-family: MicrosoftYaHei;margin-top:36px;font-size: 14px;color: #333333;"><div style="margin-top:15px">【部门授权分拨】支持管理员给下级部门分拨授权，同时可以由管理员自行管理本部门授权了！</div></div>  <div style="font-family: MicrosoftYaHei;font-size: 18px;color: #333333;margin-top:36px">快去体验吧！</div> <div style="display:flex;justify-content:center;margin-top:15px;"><div style="width: 80px;height: 34px;background: #0069e0;border-radius: 2px;cursor:pointer;line-height:34px;text-align:center;color:#fff" id="haha" onclick="clickFun()">了解详情</div></div></div></div>',
            position: 'right-center',
            prevBtnText: '重新演示'
        }
    }
]
//权限管理菜单菜单引导提示
const stepsPermissionManage =()=> [
    {
        element: '#adminpermissionManage',
        popover: {
            title: ' ',
            description: '<div style="padding:30px 90px 20px 90px;" ><div><div style="display:flex"><i class="iconfont icon-yijianfankui" style="color:#35B065;font-size:40px;padding-right:15px"></i> <div style="padding-top:15px;font-family: MicrosoftYaHei;font-size: 18px;color: #333333;">系统更新升级通知！</div></div>    <div style="font-family: MicrosoftYaHei;margin-top:36px;font-size: 14px;color: #333333;"><div style="margin-top:15px">【权限管理】中可以按需添加管理员了！</div></div>  <div style="font-family: MicrosoftYaHei;font-size: 18px;color: #333333;margin-top:36px">快去体验吧！</div> <div style="display:flex;justify-content:center;margin-top:15px;"><div style="width: 80px;height: 34px;background: #0069e0;border-radius: 2px;cursor:pointer;line-height:34px;text-align:center;color:#fff" id="haha" onclick="clickFun()">了解详情</div></div></div></div>',
            position: 'right-center',
            prevBtnText: '重新演示'
        }
  },
]



export {stepsAlloCation,stepsPermissionManage}


// WEBPACK FOOTER //
// ./src/js/userSteps/userstep.js